import React from 'react';

const DynamicSectionTitle = ({ section, className = '', as: Tag = 'h3' }) => {
    if (!section?.title && !section?.title_highlight) return null;

    return (
        <Tag className={className}>
            {section.title_highlight ? <span>{section.title_highlight} </span> : null}
            {section.title || ''}
        </Tag>
    );
};

export default DynamicSectionTitle;
